function overagePrice(pricingRange, quantity) {
  return ((quantity - pricingRange.end_quantity)
  * parseFloat(pricingRange.overage_price));
}

function priceWithOverage(pricingRange, quantity, price) {
  return price + parseFloat(pricingRange.price) + overagePrice(pricingRange, quantity);
}

function calculate(pricingRange, quantity, price) {
  const overageQuantity = pricingRange.end_quantity ? pricingRange.end_quantity : Infinity;

  if (quantity <= overageQuantity) return price + parseFloat(pricingRange.price);
  return priceWithOverage(pricingRange, quantity, price);
}

function stepUsage(pricingRange, quantity, price) {
  const quotations = pricingRange.filter((range) => quantity >= range.start_quantity);

  const calculedQuotations = quotations.map((quo) => (
    {
      pricingRange,
      price: calculate(quo, quantity, parseFloat(price)),
    }));

  return calculedQuotations.filter((pre) => pre.price)[0].price;
}

export default stepUsage;
